import * as React from 'react';
import Field from './Field';
import { emailValidationRegex } from '../../lib/utils';

const EmailField = (props: Props) => {
	// eslint-disable-next-line react/jsx-props-no-spreading
	return <Field {...props} type="email" validate={validateEmail} required />;
};

interface Props {
	label: string;
	name: string;
	value: string;
	onValueChange: (name: string, value: string | boolean, errorMessage: string) => void;
	errorMessage?: string;
	autoFocus?: boolean;
	disabled?: boolean;
}

EmailField.defaultProps = {
	errorMessage: null,
	autoFocus: false,
	disabled: false
};

const validateEmail = (value: string): string => {
	if (emailValidationRegex.test(value)) {
		return null;
	}
	return 'Email is invalid.';
};

export default EmailField;
